import React from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import '../../../styles/styles.css';

export default function Reporte() {
  const location = useLocation();
  const enSubruta = location.pathname !== "/dashboard/reporte";

  return (
    <div style={{ padding: '0', margin: '0', width: '100%', height: '100%' }}>
      <Outlet />
    </div>
  );
}
